import dayjs from 'dayjs';
import React, { PropsWithChildren } from 'react';

import Icons from '@/core/components/Icons';
import { ProfileTitle } from '@/core/components/ProfileDetails/components';
import type UserDomain from '@/core/lib/new-architecture/domain/user.domain';
import { useRouterContext } from '@/core/lib/router/router.context';
import Routes from '@/core/lib/router/routes';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

dayjs.locale('fr');

export const UserAboutSection: React.FC<Pick<ReturnType<UserDomain['getPublicInfo']>, 'city' | 'createdAt' | 'followersCount'> & { isSmall: boolean; isPrivate: boolean }> = ({
  city,
  createdAt,
  followersCount,
  isSmall,
  isPrivate,
}) => {
  const { t } = useTranslationContext(['common']);
  const { Link } = useRouterContext();

  const followersText = t('components.profile.public.followers', { ns: 'common', count: followersCount });

  return (
    <section className="space-y-3">
      <ProfileTitle tag="h2" isSmall={isSmall}>
        {t('components.profile.public.about-title', { ns: 'common' })}
      </ProfileTitle>
      <div className="text-body-secondary grid gap-2">
        {city && (
          <AboutLine>
            <Icons icon="pin" size="20" weight="bold" color="primary" />
            {city}
          </AboutLine>
        )}
        <AboutLine>
          <Icons icon="user" size="20" weight="bold" color="primary" />
          {t('components.profile.public.member-since', { ns: 'common', createdAt: createdAt.locale('fr').format('DD MMM YYYY') })}
        </AboutLine>
        {!!followersCount && (
          <AboutLine>
            <Icons icon="users" size="20" weight="bold" color="primary" />
            {isPrivate ? (
              <Link href={new Routes.ProfileFollowedUsersRoute()} className="underline hover:no-underline">
                {followersText}
              </Link>
            ) : (
              followersText
            )}
          </AboutLine>
        )}
      </div>
    </section>
  );
};

const AboutLine: React.FC<PropsWithChildren> = ({ children }) => <p className="grid grid-cols-[auto_1fr] gap-2">{children}</p>;
